import { useRef } from "react";
import Popup, { IPopupRef } from "./Popup.tsx";
import ButtonPopup from "../buttons/ButtonPopup.tsx";
import { IChangeDataTimeline } from "../../interfaces/IEpgPageState.ts";
import { useAppDispatch, useAppSelector } from "../../stores/store.ts";
import { PopupItemButton } from "./PopupItemButton.tsx";
import { epgPageActions } from "../epg/epgPageSlice.ts";

interface IProps {
    onChange: (timestamp: number) => void
}

const EpgPageChangeDatePopup = ({ onChange }: IProps) => {
    const dispatch = useAppDispatch();
    const changeDataTimelines = useAppSelector(store => store.epgPage.changeDateTimelines);
    const isOpen = useAppSelector(store => store.epgPage.isChangeTimelineDatePopupOpen);
    const selectedChangeDateTimelines = useAppSelector(store => store.epgPage.selectedChangeDateTimeline);
    const popupRef = useRef<IPopupRef>(null);

    const handleButtonOnClick = () => {
        if (isOpen && popupRef.current)
            popupRef.current.closePopup();
        else
            dispatch(epgPageActions.toggleIsChangeTimelineDatePopupOpen());
    }

    const handleClickChangeSelectedItem = (item: IChangeDataTimeline) => {
        dispatch(epgPageActions.setSelectedChangeDataTimeline(item));
        dispatch(epgPageActions.toggleIsChangeTimelineDatePopupOpen());
        onChange(item.timestamp);
    }

    return (
        <div className={"relative show-element-animation-ease-in-out"}>
            <ButtonPopup
                className={"min-w-28 min-h-9"}
                isOpen={isOpen}
                onClick={handleButtonOnClick}
            >
                {selectedChangeDateTimelines.name}
            </ButtonPopup>
            <Popup
                className={"z-[90] top-[2.5rem]"}
                isOpen={isOpen}
                ref={popupRef}
                title={"Wybierz dzień"}
                setIsOpen={(isOpen: boolean) => dispatch(epgPageActions.setIsChangeTimelineDatePopupOpen(isOpen))}
            >
                {changeDataTimelines.map(item => <PopupItemButton
                    id={item.name}
                    key={item.timestamp}
                    handleClick={() => handleClickChangeSelectedItem(item)}
                >
                    {item.name}
                </PopupItemButton>)}
            </Popup>
        </div>
    );
};

export default EpgPageChangeDatePopup;